import type { DropboxFile } from 'types/dropbox'
import api from '@disco/api/server'
import { TRACK } from '@disco/constants/ItemTypes'
import { getExtension } from '@disco/utils/file-utils'
import type { UploadProvider } from 'types/upload'
const provider: UploadProvider = {
  id: 'dropbox',
  title: 'Dropbox',

  async upload(shortlistId, uploadId, tempItems) {
    await api.uploadProviderFiles(provider.id, shortlistId, uploadId, tempItems)
  },

  prepareTempItems(files: DropboxFile[]) {
    return files.map(file => ({
      tempId: file.id,
      filename: file.name,
      title: file.name,
      album: undefined,
      artist: undefined,
      ext: getExtension(file.name),
      progress: 0,
      type: TRACK,
      groups: [],
      // Reference to the original file object to send to the server
      file: file,
      // Stored here so we can generically verify the file size
      size: file.bytes,
      // URL to the file
      url: file.link,
    }))
  },
}
export default provider
